export enum CourseTypeEnum {
  course = "course",
  module = "module",
  part = "part",
  multipart = "multipart",
}

export const CourseTypeNameEnum: Record<CourseTypeEnum, string> = {
  [CourseTypeEnum.course]: "Default",
  [CourseTypeEnum.module]: "Module",
  [CourseTypeEnum.part]: "Part",
  [CourseTypeEnum.multipart]: "Multipart",
};
